import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import Deco from "../../assets/images/appImages/deco.png";

function BannerHomepage() {
  let location = useLocation();
  let path = location?.pathname;
  return (
    <section className="section-banner-homepage">
      <div className="row align-items-center reverse_on_mobile">
        <div className="col-md-6 col-left-banner-accueil mb-3">
          <div className="content-col-left-banner-accueil">
            <h2 className="title-home-page">
              Mélamossa
            </h2>
            <div className="content-text-home-page-banner mt-2 mb-4">
              <p className="text-home-page-banner d-none d-md-block">
                Le pouvoir du naturel contre les taches et les imperfections
              </p>
            </div>
            <div className="container-btn-banner-accueil text-center text-lg-start">
              <NavLink className="btn btn-title-home-page" to="/produits">
                Voir nos produits
              </NavLink>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-right-banner-accueil">
          <div className="content-col-right-banner-accueil">
            <div className="container-img-col-right-banner-accueil text-center">
              {/*  */}
            </div>
            <div className="container-img-deco-banner">
              {/*  */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BannerHomepage;
